import { Box, Button } from '@mui/material';
import PaymentsIcon from './payments-icon';
import React from 'react';
import { useMediaQueries } from '@src/hooks/useMediaQueries';
import useStyles from './styles';

type Props = {
    auction: { biddingUrl: string };
    bidOnlineButtonClick?: () => void;
    contactButtonClick?: () => void;
};

const BidOnline = ({ auction, bidOnlineButtonClick, contactButtonClick }: Props) => {
    const classes = useStyles();
    const { isSmallScreen } = useMediaQueries(true);
    const goToAuctionSite = () => {
        if (bidOnlineButtonClick) {
            bidOnlineButtonClick();
        }
        window.open(auction.biddingUrl, '_blank');
    };
    const handleContactButtonPress = () => {
        if (contactButtonClick) {
            contactButtonClick();
        }
    };

    return (
        <div>
            {auction?.biddingUrl && (
                <Box display='flex' className={classes.bidOnlineContainer}>
                    <Button
                        variant='contained'
                        color='primary'
                        className={classes.bidOnlineButton}
                        onClick={goToAuctionSite}
                    >
                        {isSmallScreen && (
                            <PaymentsIcon data-testid='bid-icon' color={'white'} className={classes.bidOnlineIcon} />
                        )}
                        {'Bid Online'}
                    </Button>
                    <Button
                        variant='outlined'
                        color='primary'
                        className={`${classes.outlineButton} ${classes.contactButton}`}
                        onClick={handleContactButtonPress}
                    >
                        {'Contact'}
                    </Button>
                </Box>
            )}
        </div>
    );
};

export default BidOnline;
